import actions from "./playbackActions";
import { accessStates, playingStates } from "./playbackCommands";

const initialState = {
  playback: {},
  isPlaybackLoaded: false,
  isInitialized: false,
  nextTrack: null,
  accessState: accessStates.UNKNOWN,
  playingState: playingStates.UNKNOWN,
};

export const STATE_KEY = "playback";

const playbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOAD_PLAYBACK:
      return {
        ...state,
        isPlaybackLoaded: true,
        playback: action.payload.playback,
        currentTrack: action.payload.playback.item
          ? action.payload.playback.item.name
          : "",
        timeLeftMs: action.payload.timeLeftMs,
      };
    case actions.HANDLE_NEXT_TRACK:
      return {
        ...state,
        nextTrackUri: action.payload.trackUri,
        timeLeftMs: action.payload.timeLeftMs,
      };
    case actions.LOAD_NEXT_TRACK:
      return {
        ...state,
        nextTrack: action.payload.track,
      };
    case actions.STOP_PLAYBACK:
      return {
        ...state,
        accessState: accessStates.STOP,
      };
    case actions.START_PLAYBACK:
      return {
        ...state,
        accessState: accessStates.START,
      };
    case actions.START_INITIALIZE_PLAYBACK_REQUEST:
      return {
        ...state,
      };
    case actions.END_INITIALIZE_PLAYBACK_REQUEST:
      return {
        ...state,
      };
    case actions.SUCCESS_INITIALIZE_PLAYBACK:
      return {
        ...state,
        isInitialized: true,
      };
    default:
      return state;
  }
};

export default playbackReducer;
